import { Dialog } from "@headlessui/react"
import { useEffect, useState } from 'react'
import { IKImage } from "imagekitio-react"
import { useSelector } from "react-redux"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle, faTimes, faCheck } from "@fortawesome/free-solid-svg-icons"
import { useRef } from "react"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom"
import { checkUserAccess } from "../../redux/actions/authentication"
import { useDispatch } from "react-redux"
import { downgradeAccount } from "../../redux/actions/userActivity"
import Constants from "../../common/constants"
import { Mixpanel } from "../../config/Mixpanel"
import { SET_IS_TRIAL_BLOCKED } from "../../redux/actions/types"
import CareerModal from "./PricingAnnual/CareerModal"

export default function EntryPopUp({ setScrollToMax,isCareerGoal,setIsCareerGoal,userToggle,is_show,selected_goal, isSetGoal}) {

    const [openModal, setOpenModal] = useState(false)
    const user_name = useSelector((store) => store?.profileDetails?.name);
    const location = useLocation()
    const dispatch = useDispatch()
    const user_id = useSelector(store => store?.profileDetails?.id)
    const navigate = useNavigate()
    const email = useSelector((store) => store?.profileDetails?.email);
    const [searchParams] = useSearchParams();
    const is_whatsapp = useSelector((store)=> store?.userActivity?.is_whatsapp);
    const [isModalEnabled , setIsModalEnabled] = useState(false);
    const user_role = useSelector((store) => store?.userSubscription?.user_role);
    
   
    useEffect(() => {
                    
        
       if(user_id === 0 || user_id === undefined || user_id === null || (is_show && selected_goal)){
        setOpenModal(false);
    
       }
       else{
            dispatch(checkUserAccess((successObj) => {
                console.log(successObj)
                if (successObj?.user_access_state === 'trial_blocked') {
                    setOpenModal(true)
                    dispatch({type : SET_IS_TRIAL_BLOCKED, payload : true});

                    if(is_whatsapp){
    
                        Mixpanel.track(Constants.Mixpanel.WALL_VISIT_BOT, {
                            distinct_id: email
                        });
            
                    }
                    
                    Mixpanel.track(Constants.Mixpanel.WALL_VISIT_OVERALL, {
                        distinct_id: email
                    });

                }
                else {
                    setOpenModal(false)
                    if(user_role === 7)
                    {
                        setIsModalEnabled(true);
                    }
                    dispatch({type : SET_IS_TRIAL_BLOCKED, payload : false});
                }

            }, (err) => { }))
    }
       

    }, [location.pathname])

    console.log('location'  , location.pathname)
    console.log('Entry', userToggle , is_show , selected_goal , isSetGoal)

    if(openModal){
    return (
        <div>
            <Dialog open={openModal} onClose={() => null}
                as="div"
                style={{ zIndex: '9999999999' }}
                className="fixed inset-0 z-10 overflow-y-auto flex md:justify-start md:mt-20 -mt-10 justify-center flex-col items-center">
                <Dialog.Overlay className="fixed inset-0 bg-black opacity-70 z-10" />
                <Dialog.Title />
                <Dialog.Description />
            
                    
                        <div className='relative bg-white z-10 md:w-1/4 lg:w-[28%] w-[95%] rounded-xl flex flex-col justify-start py-4 px-4 items-center md:p-4 text-center shadow-2xl'>
                            <img
                                urlEndpoint="https://assets.learntube.ai/files/"
                                src='https://assets.learntube.ai/files/8_day_journey/lockKey.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1669360270828'
                                transformation={[{
                                    "height": "150",
                                    "width": "150",
                                }]}
                                className="h-40 w-40"
                            />
                            <h1 className="font-bold text-xl">{user_name?.split(" ")?.[0]}, Your LearnTube Max trial is Over!</h1>
                            <p className="my-4">To enjoy certified learning, live workshops & 120% placement support invest in your career growth with the Max plan</p>
                            <div className="flex justify-center items-center w-full">
                                <button className="border-2 mx-1 border-[#13B284] focus:outline-none px-4 text-sm py-2 text-[#13B284] font-semibold rounded-lg" onClick={() =>
                                    {
                                        
                                        Mixpanel.track(Constants.Mixpanel.WALL_EXPLORE_ALL, {
                                            distinct_id: email
                                        });
                                        setOpenModal(false);
                                        setIsModalEnabled(true);
                                        }}>Explore All Options</button>
                                <button className="mx-1 bg-[#13B284] px-4 text-sm py-2 border-2 border-[#13B284] text-white font-semibold rounded-lg" onClick={(e)=>{
                                    Mixpanel.track(Constants.Mixpanel.WALL_EXPLORE_MAX, {
                                        distinct_id: email
                                    });
                                    setOpenModal(false);
                                    setScrollToMax(3);
                                    setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal : { goal_name :'Placements' , product:"LearnTube Max" } }))
                                }}>Explore Max Plan</button>
                            </div>
                            <p className="mt-1 text-xs self-start ml-8 md:ml-10 font-medium">From ₹0 to ₹12,499</p>
                        </div>
                     
            </Dialog>
        </div>
    
    )
                            }
    else{
        return <>{!userToggle && !isSetGoal && <CareerModal isModalEnabled={isModalEnabled} setIsModalEnabled={setIsModalEnabled} setIsCareerGoal={setIsCareerGoal} isSetGoal={isSetGoal}/>}</>
    }
}